import { Subject } from 'rxjs';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { ISnAuthConfig } from '@lib/auth';
import { snFadeInDown } from '@lib/common/animations';
import { t } from '@lib/translation/helpers';

import { SN_AUTH_CONFIG } from '../../providers';
import { SnSessionService } from '../../services';
@Component({
  selector: 'sn-cjis-compliance',
  templateUrl: './cjis-compliance.component.html',
  styleUrls: ['./cjis-compliance.component.scss'],
  animations: [snFadeInDown],
})
export class CjisComplianceComponent implements OnDestroy, OnInit {
  public _redirectUrl: string;
  public complianceMessage: string;
  public complianceTitle: string;
  public isLoading = false;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    activatedRoute: ActivatedRoute,
    private readonly _dialogRef: MatDialogRef<CjisComplianceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; title: string },
    private readonly _sessionService: SnSessionService,
    @Inject(SN_AUTH_CONFIG) authConfig: ISnAuthConfig,
  ) {
    const queryParams = activatedRoute.snapshot.queryParams;
    this._redirectUrl = queryParams.redirectUrl || authConfig.redirectAuthorizedTo;
    this.complianceMessage = data.message;
    this.complianceTitle = data.title || t('auth.cjisCompliance.title');
  }

  public ngOnInit(): void {}

  public aceptedCJIS(): void {
    this._dialogRef.close(true);
  }

  public logOut(): void {
    this._dialogRef.close();
    this._sessionService.logout({
      reason: 'cjisCompliance:closed',
    });
  }

  public close(): void {
    this._dialogRef.close(false);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
